import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isMarkActive, toggleMarkCommand } from '../utils/markUtils';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { BoldIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { Tracker } from '../../utils/usageTracker';
import { PM_FORMATTING } from '../constants/events';
import { CHANGE_INLINE_STYLE } from 'rich-text-lib/constants/usageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const toggleBold = toggleMarkCommand(schema => schema.marks.strong);
export default function BoldMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const toggleBoldMark = useCallback(e => {
    e.preventDefault();
    toggleBold(editorState, tr => setEditorState(editorState.apply(tr)));
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_INLINE_STYLE,
      method: 'toolbar',
      value: 'bold'
    });
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.bold"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      onMouseDown: toggleBoldMark,
      "data-test-id": "bold",
      selected: editorState && isBold(editorState),
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: BoldIcon
      })
    })
  });
}
function isBold(state) {
  return isMarkActive(state, state.schema.marks.strong);
}